import examScheduleActions from './actions';

const initialState = {
    scheduleCourses: [],
    sectionRows: [],
    paperRows: [],
    schedulePreview: null,
};

const examScheduleReducer = (state = initialState, action) => {

    switch (action.type) {
        case examScheduleActions.SET_SCHEDULE_COURSES:
            return {
                ...state,
                scheduleCourses: action.payload
            }

        case examScheduleActions.SET_EXAM_SCHEDULE:
            return {
                ...state,
                sectionRows: action.payload
            }

        case examScheduleActions.SET_EXAM_PAPERS:
            return {
                ...state,
                paperRows: action.payload
            }

        case examScheduleActions.SET_SCHEDULE_PREVIEW:
            return {
                ...state,
                schedulePreview: action.payload
            }

        default:
            return state
    };
};

export default examScheduleReducer;
